export default {
  OK: "အိုကေ",
  CLOSE: "အကောင့်ပိတ်ထားသည်",
  BLOCK: "အကောင့်ပိတ်ထားသည်",
  FREEZE: "အကောင့်အား ခေတ္တပိတ်ထားသည်",
  SUSPEND: "သင်၏အကောင့်အား ကြည့်ရှုရန်သာ ခွင့်ပြုထားသည် ",
  passwordRequired: "စကားဝှက်အား ထည့်ရန်",
  usernameRequired: "Username ထည့်ရန် ",
  incompletedRequest: "တခုခု မှားယွင်းနေသည် ...",

  session_not_exists: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  session_expired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  invalidSession: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  accountIdRequired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  NoUserAccessRight: "ခွင့်ပြုထားခြင်းမရှိပါ သင်၏ အေးဂျင့်အား ဆက်သွယ်ပါ...",
  account_not_exists: "username မှားယွင်းနေသည် .",
  invalid_password: "စကားဝှက် မှားယွင်းနေသည် ",
  secondary_account_exists: "သင်၏ Nickname အား ပြုလုပ်ပြီးပါပြီ ",
  systemError: "အတွင်းစနစ် မှားယွင်းနေသည် ",
  new_login_id_exists: "အမည်မှားယွင်းနေသည် ၊ အခြားအမည်ဖြင့် အသုံးပြုပါ",
  loginLimit: "Login ဝင်ရောက်ခြင်း အကြိမ်များနေပါသည် ။ နောက်တစ်မိနစ်ကြာမှ ပြန်လည်ဝင်ရောက်ပါ ",
  requestLimit: "တောင်းဆိုမှု အကြိမ်များနေပါသည် .",
  unableToGetBalanceAtTheMoment: "Internal Server Error.",
  oddsDisplayInvalid: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  oddsIsUpdating: "စျေးပြင်ဆင်နေသည် ...",
  atLeastTwoMatchToBetParlay: "မောင်းကစားနည်းအား အနည်းဆုံး ၂ ပွဲ ကစားရန်.",
  atLeastThreeMatchToBetParlay: "At least mix three matches to bet in parlay.",
  duplicate_debit_record: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",

  insufficient_balance: "ငွေမလောက်ပါ",
  betOverMaxPerMatch: "သတ်မှတ်လောင်း‌ကြေးထက် ကျော်လွန်နေသည်.",
  betOverMax: "သတ်မှတ်လောင်း‌ကြေးထက် ကျော်လွန်နေသည်.",
  betOverMaxBet: "သတ်မှတ်လောင်းကြေးထက်ကျော်လွန်နေသည်.",
  betLowerMin: "သတ်မှတ်လောင်း‌ကြေးထက် လျော့နည်းနေသည်.",

  loginFailed: "ဝင်ရောက်၍ မရပါ ၊ ပြန်လည်ကြိုးစားပါ ...",
  requestFailed: "တောင်းဆိုမှု မအောင်မြင်ပါ ၊ သင်၏ အင်တာနက်အား စစ်ဆေးပါ ",
  requestPending: "တောင်းဆိုနေသည် ...",

  close: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  suspend: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  freeze: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",

  alphaNumOnly: "ဂဏာန်းနှင့် စာသားသာ အသုံးပြုရန် ",

  // vuelidate
  isRequired: "{fname} အားဖြည့်ပါ.",
  isMinValue: "{fname} အနည်းဆုံး {fvalue}.",
  isMaxValue: "{fname} အများဆုံး {fvalue}.",
  isMinLength: "{fname} အနည်းဆုံးစာသား {fvalue}.",
  isMaxLength: "{fname} အများဆုံးစာသား {fvalue}.",
  isAlpha: "{fname} အား အင်္ဂလိပ်စာသားသာ အသုံးပြုရန် .",
  isAlphaNum: "{fname} အား အင်္ဂလိပ်ဂဏာန်းသာ အသုံးပြုရန် .",
  isNumeric: "{fname} အား ဂဏာန်းသာ အသုံးပြုရန် .",
  isEmail: "{fname} - email လိပ်စာ အသုံးပြုရန် .",
  isIpAddress: "{fname} IPv4 လိပ်စာ အသုံးပြုရန် .",
  isSameAs: "{fname} နှင့်  {fname2} ဆင်တူရမည် .",
  isUrl: "{fname} URLs သာ အသုံးပြုရန် .",
  containAlphaNum: "{fname} အနည်းဆုံး စာသားတစ်ခုနှင့် ဂဏာန်းတစ်ခု ရှိရမည် .",
  selectOption: "{fname} အား ရွေးချယ်ပါ ",
  notSameAs: "{fname} နှင့် {fname2} မတူရပါ.",

  currPasswordRequired: "လက်ရှိစကားဝှက်!",
  newPasswordRequired: "စကားဝှက်အသစ်!",
  confirmNewPasswordRequired: "စကားဝှက်အသစ်အား အတည်ပြုပါ!",
  passwordsNotMatch: "စကားဝှက်မှားယွင်းနေပါသည်!",
  nickNameRequired: "Nick Name အားထည့်သွင်းပါ!",

  startDateRequired: "စတင်သည့်ရက်စွဲ ထည့်သွင်းပါ!",
  endDateRequired: "ပြီးဆုံးမည့် ရက်စွဲ ထည့်သွင်းပါ!",
  pageSizeRequired: "Page Size ထည့်သွင်းရန်!",
  pageNumberRequired: "Page Number ထည့်သွင်းရန်!",
  sportsTypeRequired: "Sport Type ထည့်သွင်းရန်!",

  workingDateRequired: "Working Date ထည့်သွင်းရန်!",
  leagueIdRequired: "League ID ထည့်သွင်းရန်!",
  isOutrightRequired: "Is Outright ထည့်သွင်းရန်!",

  maxParlayTicket: "မောင်းကစားနည်း၏ အမြင့်ဆုံး ပွဲသတ်မှတ်ချက် ရောက်ရှိနေသည်!",
  matchHide: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားပွဲကို ရွေးချယ်ပါ",
  matchNotAllowBet: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  matchNotActive: "This match is not available, please try match markets.",
  invalidBets: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",

  invalidOddsBall: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  selectLeague: "အနည်းဆုံး လိဒ် ၁ ခု ရွေးချယ်ပါ",
  liveCasinoDisabled: "Live Casino ပိတ်ထားသည်",
  lotteryDisabled: "Lottery ပိတ်ထားသည်",
  slotDisabled: "Slot Disabled",
  MiniGameDisabled: "Mini Game Disabled",
  EsportsDisabled: "E-Sports Game Disabled",
  betTypeRequired: "ကစားနည်းအား ရွေးချယ်ပါ.",
  betAmountRequired: "လောင်း‌ကြေးအား ရွေးချယ်ပါ.",
  invalidBetAmount: "လောင်းကြေးငွေပမာဏ မှားယွင်းနေသည်.",
  currencyNotSupported: "မတူညီသော ငွေကြေးကြောင့် လက်မခံပါ",
  game_maintenance: "ကစားပွဲ ပြုပြင်နေသည်.",
  forbiddenAccess: "ဝင်ရောက်ခြင်းအား ပိတ်ထားသည်",
  invalidCurrency: "ငွေမလောက်ပါ.",
  connectionFailed: "Failed to link wallet system.",

  //tournament
  login_id_not_exists: "Invalid login, please try to login again.",
  noMatchSelected: "Please select at least 1 match.",
  invalidRoomRate: "Invalid room rate.",
  invalidRoomLimit: "Invalid room limit.",
  invalidRoomPassword: "Invalid PIN Code. PIN code must be 6 digit numbers.",
  invalidPassword: "Invalid Password",
  roomPasswordRequired: "PIN Code is required.",
  minMatch: "Minimum 3 matches selected.",
  maxMatch: "Maximum {max} matches selected!",
  roomIdRequired: "Room ID is required.",
  roomTypeRequired: "Room type is required.",
  sessionTokenRequired: "Session token is required.",
  matchDateRequired: "Match date is required.",
  matchRequired: "Match is required.",
  roomLimitRequired: "Room limit is required.",
  roomRateRequired: "Room rate is required.",
  minRoomRate: "Entry fee must be equal or more than 10.",
  maxRoomRate: "Entry fee must be equal or less than 1000.",
  minRoomLimit: "No. of Players must be equal or more than 3.",
  maxRoomLimit: "No. of Players must be equal or less than 30.",
  invalidRoomType: "Invalid room type.",
  invalidMatch: "Invalid match.",
  dataError: "Data Error",
  MemberExists: "Member already exist.",
  invalidMember: "Invalid member.",
  invalidleague: "Invalid league.",
  "createRoomFailed-1": "Create room failed 1.",
  "createRoomFailed-2": "Create room failed 2.",
  "createRoomFailed-3": "Create room failed 3.",
  invalidOperator: "Invalid operator.",
  roomFull: "Room is already full.",
  memberExists: "Member already exist.",
  "joinFailed-1": "Join room failed 1.",
  "joinFailed-2": "Join room failed 2.",
  IPJoinedBefore: "IP joined before.",
  memberJoinedBefore: "You have already joined before, please take note that public free room only can join once.",
  roomNotExists: "Room not exist.",
  roomIsPublicFree: "Room is public free.",
  roomEndedOrCancelled: "Room ended or cancelled.",
  roomEnded: "Room already ended.",

  matchLowerMin: "Match lower min error occured.",
  matchOverMax: "Match over max error occured.",
  pointsOverLimit: "Points over limit error occured.",
  roomOverMax: "Room over max error occured.",
  invalidRoom: "Invalid room.",
  roomLimitOverMax: "Room limit over max error occured.",
  rateLowerMin: "Rate lower min error occured.",
  rateOverMax: "Rate over max error occured.",

  liveMatchNotAllowed: "Live match not allowed.",
  roomLimitLowerMin: "Room limit lower min error occured.",
  roomClosed: "Room closed.",
  tournamentLeagueExists: "Tournament league exists.",
  roomExists: "Not allow to create more than 1 private room.",
  RoomExists: "Not allow to create more than 1 private room.",
  betExists: "Bet already exists.",
  roomClosedNotAllowed: "Room closed not allowed.",
  tournamentMatchExists: "Tournament match exists.",
  account_id_required: "Account ID is required.",
  agent_comm_rate_required: "Agent commission rate is required.",
  agent_id_required: "Agent ID is required.",
  bet_amount_required: "Bet amount is required.",
  bet_id_required: "Bet ID is required.",
  credit_amount_required: "Credit amount is required.",
  currency_required: "Currency is required.",
  debit_amount_required: "Debit amount is required.",
  duplicate_credit_record: "Duplicate credit record.",
  master_comm_rate_required: "Master commission rate is required.",
  master_id_required: "Master ID is required.",
  member_id_required: "Member ID is required.",
  member_wallet_not_exists: "Member wallet not exists.",
  permission_denied: "Permission denied.",
  rate_required: "Rate is required.",
  result_exists: "Result already exists.",
  room_id_required: "Room ID is required.",
  s_senior_comm_rate_required: "Super Senior commission rate is required.",
  s_senior_id_required: "Super Senior ID is required.",
  senior_comm_rate_required: "Senior commission rate is required.",
  senior_id_required: "Senior ID is required.",
  shareholder_comm_rate_required: "Shareholder commission rate is required.",
  shareholder_id_required: "Shareholder ID is required.",
  transfer_id_required: "Transfer ID is required.",
  minBetAmount: "Minimum bet amount error occured.",
  tournamentDisabled: "The tournament is disabled, please check contact your upline.",
  // tournamentDisabled: "Tournament coming soon. Please stay tune!!",
  marketTypeRequired: "Market Type is required.",
  invalidMarketType: "Invalid market type provided.",
  marketTypeChanged: "Bet Slip has been removed due to market type changed.<br />Please select again from the market.",
  changeStakeMin: "Input stake amount been changed due to MIN limit.",
  changeStakeMax: "Input stake amount been changed due to MAX limit.",
  betNotExists: "Please place a valid bet to join the tournament.",
  cashOutUnavailable: "Keluar tidak tersedia.",
  errorCashoutAmount: "Keluar sedang diperbarui...",
  freeRoomNeedBet: "Silakan pasang taruhan yang valid untuk mengakses ruangan gratis.",

  startTimeRequired: "စတင်ချိန် လိုအပ်ပါသည်။",
  endTimeRequired: "ပြီးဆုံးချိန် လိုအပ်ပါသည်။",
  oddsTypeIDRequired: "Odds အမျိုးအစား လိုအပ်ပါသည်။",
  commissionRequired: "ကော်မရှင် လိုအပ်ပါသည်။",
  requestTimeRequired: "တောင်းဆိုချိန် လိုအပ်ပါသည်။",
  statusRequired: "အခြေအနေ လိုအပ်ပါသည်။",
  invalidStartTime: "စတင်ချိန် မမှန်ကန်ပါ။",
  invalidEndTime: "ပြီးဆုံးချိန် မမှန်ကန်ပါ။",
  invalidOddsTypeID: "Odds အမျိုးအစား မမှန်ကန်ပါ။",
  invalidCommission: "ကော်မရှင် မမှန်ကန်ပါ။",
  invalidRequestTime: "တောင်းဆိုချိန် မမှန်ကန်ပါ။",
  invalidStatus: "မမှန်ကန်သော အခြေအနေ",
  invalidAlgoMatchInfo: "ဤဈေးကွက်ပိတ်ထားပါသည်၊ ကျေးဇူးပြု၍ အခြားဈေးကွက်များကို စမ်းကြည့်ပါ။ (-၁၀၁)",
  invalidAlgoSliderLeagueInfo: "လိဂ်အချက်အလက် မမှန်ကန်ပါ။",
  invalidAlgoSliderMinutesWeight: "မိနစ်အလေးချိန် မမှန်ကန်ပါ။",
  invalidAlgoSliderBetType: "လောင်းကြေး မမှန်ကန်ပါ။ အမျိုးအစား။",
  invalidRTSRunningScoreDetails: "မမှန်ကန်သော ပြေးရမှတ်အသေးစိတ် (RTS)။",
  invalidProviderGoalTimeLine: "မမှန်ကန်သော ပံ့ပိုးပေးသူရည်မှန်းချက်အချိန်ဇယား။",
  invalidSliderTimeRange: "မမှန်ကန်သော အချိန်အပိုင်းအခြား။",
  invalidMOMatchOdds: "ပွဲစဉ်အခွင့်အလမ်းများကို အပ်ဒိတ်လုပ်နေသည်...၊",
  invalidProviderSlider: "မမှန်ကန်သော TM အချက်အလက်။",
  invalidCombineBetTypeAndOddsFormat: "လောင်းကစားအမျိုးအစားနှင့် အခွင့်အလမ်းပုံစံပေါင်းစပ်မှု မမှန်ကန်ပါ။",
  invalidMatchInformation: "မမှန်ကန်သော ပွဲစဉ်အချက်အလက်။",
  marketClose: "ဤဈေးကွက်ပိတ်ထားပါသည်၊ ကျေးဇူးပြု၍ အခြားဈေးကွက်များကို စမ်းကြည့်ပါ။ ",
  error: "အမှား"
};


// export default {
//   OK: "OK",
//   CLOSE: "Account has been closed!",
//   passwordRequired: "Password is required!",
//   usernameRequired: "Username is required!",

//   session_not_exists: "Session expired! Please login again to continue...",
//   session_expired: "Session expired! Please login again to continue...",
//   invalidSession: "Session expired! Please login again to continue...",
//   accountIdRequired: "Session expired! Please login again to continue...",
//   NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
//   account_not_exists: "Invalid password.",
//   invalid_password: "Invalid password.",
//   secondary_account_exists: "Your nickname already created.",
//   systemError: "Internal System Error.",
//   new_login_id_exists: "Invalid nickname, please try to set different nickname.",
//   loginLimit: "You have login too frequent, please try again after 1 minute...",
//   requestLimit: "You have request too frequent.",
//   unableToGetBalanceAtTheMoment: "Internal Server Error.",
//   oddsDisplayInvalid: "Invalid Odds Display.",
//   oddsIsUpdating: "Odds Is Updating...",
//   atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",

//   insufficient_balance: "Insufficient Balance",
//   betOverMaxPerMatch: "Your stake exceeds the max stake.",
//   betOverMax: "Your stake exceeds the max stake.",
//   betLowerMin: "Your stake less than the min stake.",


//   loginFailed: "Login failed, please try again later...",
//   requestFailed: "Request failed, please check your internet connection.",

//   close: "Account is closed! Please contact your upline to continue...",
//   suspend: "Account is suspend! Please contact your upline to continue...",
//   freeze: "Account is freeze! Please contact your upline to continue...",

//   alphaNumOnly: "Alphanumeric only",

//   // vuelidate
//   isRequired: "Please enter a {fname}.",
//   isMinValue: "{fname} must have minimal of {fvalue}.",
//   isMaxValue: "{fname} must be less than or equal to {fvalue}.",
//   isMinLength: "{fname} must have at least {fvalue} characters.",
//   isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
//   isAlpha: "{fname} accept only alphabet.",
//   isAlphaNum: "{fname} accept only alphanumerics.",
//   isNumeric: "{fname} accept only numerics.",
//   isEmail: "{fname} accept only valid email addresses.",
//   isIpAddress: "{fname} accept only valid IPv4 addresses.",
//   isSameAs: "{fname} must be same as {fname2}.",
//   isUrl: "{fname} accept only URLs.",
//   containAlphaNum: "{fname} must have at least one alphabet and one number.",
//   selectOption: "Please select a {fname}",
//   notSameAs: "{fname} and {fname2} cannot be the same.",

//   currPasswordRequired: "Current password is required!",
//   newPasswordRequired: "New password is required!",
//   confirmNewPasswordRequired: "Confirm new password is required!",
//   passwordsNotMatch: "Passwords do not match!",
//   nickNameRequired: "Nickname is required!",

//   startDateRequired: "Start date is required!",
//   endDateRequired: "End date is required!",
//   pageSizeRequired: "Page size is required!",
//   pageNumberRequired: "Page number is required!",
//   sportsTypeRequired: "Sports type is required!",

//   workingDateRequired: "Working date is required!",
//   leagueIdRequired: "League ID is required!",
//   isOutrightRequired: "Is outright is required!"

// };
